import _ from 'lodash';
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  usePaginatedQuery, ErrorHandler, InfiniteScrollComponent, ScrollBarContainer,
} from '@playbookux/playbook-web-core';

import { TEST_SESSION_NOTES } from './graphql';
import {
  ContainerInputSearch,
  ContainerListClips,
  InputSearch,
  Message,
} from './style';

import CardClip from './card-clip';

import { ClipsZeroState } from '../../../../components/zero-state';
import useDebounce from '../../../../../core/hooks/use-debounce';

const LIMIT = 12;
const DEBOUNCE_TIME = 700;

const ListClips = (props) => {
  const {
    companyId,
    clipsMap,
    onShowClip,
  } = props;

  const scrollParentRef = useRef(null);

  const [search, setSearch] = useState(null);
  const [debouncedSearch] = useDebounce(() => search, DEBOUNCE_TIME, [search]);

  const {
    loading,
    error,
    data = {},
    fetchMore,
    hasMore,
  } = usePaginatedQuery(TEST_SESSION_NOTES, {
    variables: {
      companyId,
      limit: LIMIT,
      offset: 0,
      order: 'created_at DESC',
      noteType: 'clip',
      search: debouncedSearch || undefined,
    },
  }, {
    dataField: 'testSessionNotes',
  });

  const { testSessionNotes = [] } = data;

  const handleSearchChange = (e, { value }) => setSearch(value);

  const handleShowClip = (noteId) => {
    onShowClip(noteId);
  };

  const verifyIfClipsWereMovedFromScrollList = (clipValues) => {
    if (!debouncedSearch) return false;

    let isClipMoved = true;

    _.forEach(clipValues, (clip) => {
      if (!clipsMap[clip.id]) {
        isClipMoved = false;
      }
    });

    return isClipMoved;
  };

  const zeroState = !loading && !error && _.isEmpty(testSessionNotes);
  const noResults = zeroState && !_.isEmpty(search);

  const filteredClips = testSessionNotes.filter((testSessionNote) => !clipsMap[testSessionNote.id]);

  if (hasMore && filteredClips.length < 7) fetchMore();

  return (
    <ContainerListClips>
      <ScrollBarContainer ref={scrollParentRef}>
        <ContainerInputSearch>
          <InputSearch
            icon="search"
            placeholder="Search project name, notes"
            input={{
              icon: 'search',
              iconPosition: 'left',
            }}
            onSearchChange={handleSearchChange}
            value={search || ''}
            showNoResults={false}
          />
        </ContainerInputSearch>

        {zeroState && !noResults && (
          <ClipsZeroState />
        )}

        {!loading && (noResults || verifyIfClipsWereMovedFromScrollList(testSessionNotes)) && (
          <Message>No results found</Message>
        )}

        {error && (
          <ErrorHandler
            error={error}
            defaultMessage="Error while retrieving the clips."
          />
        )}

        <InfiniteScrollComponent
          hasMore={hasMore}
          onLoadMore={fetchMore}
          getScrollParent={() => scrollParentRef.current}
        >
          {filteredClips.map((testSessionNote) => (
            <CardClip
              key={testSessionNote.id}
              testSessionNote={testSessionNote}
              onClipPlay={handleShowClip}
            />
          ))}
        </InfiniteScrollComponent>
      </ScrollBarContainer>
    </ContainerListClips>
  );
};

ListClips.propTypes = {
  companyId: PropTypes.string.isRequired,
  clipsMap: PropTypes.shape({}).isRequired,
  onShowClip: PropTypes.func.isRequired,
};

export default ListClips;
